import { ENTERPRISES } from '../types/enterprise'
// import { useStorage } from '@vueuse/core'

// TODO: Enable local storage when enterprise is ready

// const enterpriseStorage = useStorage('current_enterprise', ENTERPRISES[0].id)
export const useEnterprise = () => useState<number>('enterprise', () => ENTERPRISES[0].id)
export const setEnterprise = (enterprise_id: number) => {
  const currentEnterprise = useEnterprise()
  // enterpriseStorage.value = enterprise_id

  currentEnterprise.value = enterprise_id
}
